import TurnstileService from './frontend/Services/TurnstileService';

TurnstileService.load();
